export default __webpack_public_path__ + "static/media/Group 1045.45d41175.svg";